import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df17b3c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-wrapper" }




export default /*#__PURE__*/_defineComponent({
  props: { title: String },
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.title), 1))
}
}

})